import { j as l } from "../../../../jsx-runtime.BREq8dyb.js";
import { memo as p, useState as c } from "react";
import { z as e } from "../../../../zod.BRvRcVQy.js";
import "../../contexts/DatasetContext/DatasetContext.js";
import "../../contexts/FeatureContext/FeatureContext.js";
import "../../contexts/FileContext/FileContext.js";
import "../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../contexts/NavigatorContext/NavigatorContext.js";
import "../../contexts/OptionsContext/OptionsContext.js";
import { SchemaProvider as d } from "../../contexts/SchemaContext/SchemaContext.js";
import "../../contexts/TypificationContext/TypificationContext.js";
import "../../contexts/WorkerContext/WorkerContext.js";
const f = p(({
  children: o,
  schema: t,
  deferred: a = !1
}) => {
  e.object({
    columns: e.array(e.object({
      default: e.string().nullable().optional(),
      formatType: e.enum(["DATE_ISO8601", "EMAIL", "FLOAT", "HASH_SHA256_HEX", "INTEGER", "PHONE_NUMBER_E164", "STRING"]),
      hashWith: e.enum(["SHA256_HEX"]).nullable(),
      id: e.string(),
      name: e.string(),
      nullable: e.boolean()
    }).partial({
      hashWith: !0
    })),
    uniqueColumnIds: e.array(e.array(e.string()))
  }).partial({
    uniqueColumnIds: !0
  }).refine((n) => {
    const m = n.uniqueColumnIds?.flat() || [], u = n.columns?.flatMap(({
      id: r
    }) => r) || [];
    return m.every((r) => u.includes(r));
  }, {
    message: "`uniqueColumnIds` ids can only reference existing `columns` ids",
    path: ["uniqueColumnIds"]
  }).nullish().parse(t);
  const [i, s] = c(t);
  return /* @__PURE__ */ l.jsx(d, { value: {
    deferred: a,
    schema: i,
    setSchema: s
  }, children: o });
});
f.displayName = "SchemaContainer";
export {
  f as default
};
//# sourceMappingURL=SchemaContainer.js.map
